
/**
 * @fileOverview GlobalEventDispatcher creates a single instance of a EventDispatcher that can be included in, and
 * shared with modules throughout the application.  This makes sure that all objects are using the same instance
 * of an EventDispatcher, while removing the need to have the application file manage it.
 *
 * @author Kevin Moot <kmoot@nerdery.com>
 * @contributor Jeff Maki <jmaki@nerdery.com>
 *
 * NOTE: THIS REQUIRE MODULE IS NAME SPACED, AND NEEDS TO HAVE ITS WRAPPER FUNCTION REMOVED IN ORDER TO REUSE ELSEWHERE *
 *
 * @version 1.0
 */

(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('GlobalEventDispatcher',['require','models/EventDispatcher'],function (require) {
        
        var EventDispatcher = require('models/EventDispatcher');

        /**
         * Traps an instance of the event dispatcher for us in various components
         * @constructor
         * @static
         */
        var GlobalEventDispatcher = {};

        GlobalEventDispatcher.eventDispatcher = new EventDispatcher();

        /**
         * Returns the local instance of an EventDispatcher
         *
         * @return {EventDispatcher}
         */
        GlobalEventDispatcher.getEventDispatcher = function () {
            return this.eventDispatcher;
        };

        /**
         * Creates a centralized list of Events that can be used with the EventDispatcher.  These events can be triggered
         * and subscribed to with or without using the EVENTS object but should use the EVENTS object except in the case
         * where the specific event is defined in as an data attribute within a DOM element.
         *
         * When adding events, add a brief description for what the event represents.
         *
         * @type {Object}
         */ 
        GlobalEventDispatcher.EVENTS = {
            CONTEXT_CHANGE: 'ContextChange',    /* the page transitions between breakpoints */            
            WINDOW_RESIZE: 'windowResize',      /* the window changes size, could be on orientation change*/
            CAROUSEL_UPDATE: 'carouselUpdate',  /* a carousel has updated its position */
            CONTENT_UPDATED: 'contentUpdated',  /* a content view has updated its visible content */
            CONTENT_OPEN: 'contentOpen',        /* Content has been toggled open, drawer etc. */
            MODAL_OPEN: 'modalOpen',            /* a modal has opened on the page */
            MENU_OPEN: 'menuOpen',              /* a menu opened */
            MENU_CLOSE: 'menuClose',            /* a menu closed */
            CONTENT_CLOSE: 'contentClose',      /* Content has been closed, drawer, etc.*/
            LUXURY_CONTEXT: 'luxuryContext',    /* Entered Luxury Context*/
            LARGE_CONTEXT: 'largeContext',      /* Entered Large Context*/
            MEDIUM_CONTEXT: 'mediumContext',    /* Entered Medium Context*/
            SMALL_CONTEXT: 'smallContext',     /* Entered Small Context*/
            MODIFIED_CHANGE: 'ContextChange',    /* the page transitions between breakpoints */
            LUXURY_MODIFIED: 'luxuryModified',    /* Entered Luxury Context*/
            LARGE_MODIFIED: 'largeModified',      /* Entered Large Context*/
            MEDIUM_MODIFIED: 'mediumModified',    /* Entered Medium Context*/
            SMALL_MODIFIED: 'smallModified'     /* Entered Small Context*/
        };

        return GlobalEventDispatcher;
    });

}(MMMRequire));

